import React from 'react';
import styled from 'styled-components';
import { Popover } from 'antd';
import { InfoCircleOutlined, FireTwoTone, StarTwoTone, DollarCircleOutlined, MessageFilled } from '@ant-design/icons';
import { BOXED_SET_CDN_URL } from '../core/constants/global-constants';

const Info = styled.span`
  margin: 0 8px;
`;

interface INotesIconProps {
  count: number;
  onClick: (e: React.MouseEvent) => void;
}

export const Hint = ({ hint, color }) => (
  <Popover content={<p>{hint}</p>}>
    <Info><InfoCircleOutlined style={{ color, fontSize: '15px' }}/></Info>
  </Popover>
);

export const BoxedSetTag = ({ hint }) => (
  <Popover content={<p>{hint}</p>}>
    <Info><img src={BOXED_SET_CDN_URL} alt='Book Set' style={{ width: '15px', height: '15px' }} /></Info>
  </Popover>
);

export const LateBloomerTag = ({ hint, color }) => (
  <Popover content={<p>{hint}</p>}>
    <Info><FireTwoTone twoToneColor={color} style={{ fontSize: '15px', marginBottom: '8px' }}/></Info>
  </Popover>
);

export const RisingStar = ({ hint, color }) => (
  <Popover content={<p>{hint}</p>}>
    <Info><StarTwoTone twoToneColor={color} style={{ fontSize: '15px' }}/></Info>
  </Popover>
);

export const PoorROI = ({ hint, color }) => (
  <Popover content={<p>{hint}</p>}>
    <Info><DollarCircleOutlined style={{ color, fontSize: '15px' }}/></Info>
  </Popover>
);

export const NotesBadge: React.FC<INotesIconProps> = ({ count, onClick }) => (
  <div onClick={(e) => {
    e.stopPropagation();
    onClick(e);
  }}
  style={{ paddingBottom: '2px' }}
  >
    <MessageFilled style={{ color: '#8278FF' }} size={25} /> {' '}
    {count}
  </div>
);